// https://github.com/maoberlehner/vue-lazy-hydration

import Vue from "vue"
import LazyHydrate from "vue-lazy-hydration"

Vue.component("LazyHydrate", LazyHydrate)
